import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DialogWarningData } from '@shared-models';

@Component({
  selector: 'app-dialog-warning',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './dialog-warning.component.html',
  styleUrl: './dialog-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogWarningComponent {
  //#region Dependencies

  data: DialogWarningData = inject(MAT_DIALOG_DATA);

  //#endregion
}
